import React from "react";

/* Import Boostrap */
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

class Heading1 extends React.Component { 
    constructor(props) {
        super(props);
        this.state = { 
            class : 'animate-box' 
        }
    }
    componentDidMount = () => {
        var that = this;
        setTimeout(function() {
            that.show();
        }, that.props.wait);
    } 
    show = () => {
        this.setState({class : this.props.className});
    }    
    render () {
        return (
          <h1 className={ this.state.class }>{ this.props.translate(this.props.title) }</h1>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
  return {
    translate: getTranslate(state.locale),
    props: ownProps
  };
};

export default connect(mapStateToProps)(Heading1);




// WEBPACK FOOTER //
// ./src/components/titles/Heading1.js